import React, { Component, ErrorInfo, ReactNode } from 'react';
import '../../../../_metronic/assets/sass/BillingStyles.scss';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onReset?: () => void;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ errorInfo });
    console.error('Uncaught React Runtime Error:', error, errorInfo);
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    if (this.props.onReset) {
      this.props.onReset();
    }
  };

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className='error-boundary-wrapper'>
          <div className='card shadow-sm border border-danger border-dashed p-6 text-center error-boundary-card'>
            <div className='mb-4'>
              <span className='svg-icon svg-icon-5x text-danger d-inline-block'>
                <i className='bi bi-exclamation-octagon-fill fs-2x text-danger'></i>
              </span>
            </div>
            <h3 className='fw-bolder text-gray-800 mb-2'>Terjadi Kendala pada Modul Ini</h3>
            <p className='text-muted fs-7 mb-4'>
              Komponen mengalami kesalahan pemrosesan data (runtime exception). Bagian lain dari sistem tetap dapat digunakan dengan normal.
            </p>

            {this.state.error && (
              <div className='text-start p-3 rounded mb-4 font-monospace fs-8 text-danger error-boundary-trace'>
                <strong>Error:</strong> {this.state.error.toString()}
              </div>
            )}

            <div className='d-flex justify-content-center gap-2'>
              <button
                type='button'
                className='btn btn-sm btn-primary'
                onClick={this.handleReset}
              >
                <i className='bi bi-arrow-clockwise me-1'></i> Coba Muat Ulang Modul
              </button>
              <button
                type='button'
                className='btn btn-sm btn-light'
                onClick={() => window.location.reload()}
              >
                Muat Ulang Halaman
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
